import styled from '@emotion/styled';
export const DatePickerWrapper = styled('div')`
  .MuiFormControl-root{
    width: 100%;
  }
  .MuiInputBase-input {
    height: 18px;
  }
`;

export const InputErrorMessage = styled('div')`
    font-family: Roboto-Regular;
    font-weight: 700;
    font-size: 0.75rem;
    line-height: 1.5;
    letter-spacing: 0;
    text-align: left;
    margin-top: 3px;
    margin-right: 14px;
    margin-bottom: 0;
    color: red;
`;
